import { api } from "@ts/core/api";
import { Cookie } from "@ts/core/Cookie";
import { Elements } from "@ts/core/Elements";
import { instruction } from "@ts/core/Instruction";
import { simpleForm } from "@ts/core/SimpleForm";
import { uploadFile } from "@ts/core/uploadFile";
import { yesNo } from "@ts/core/YesNo";
import { MediaData } from "@ts/data/MediaData";
import { AudioSection } from "@ts/sections/AudioSection";

export function createAudioSection(): Promise<boolean> {

    return new Promise((resolve) => {
        instruction('Välj den ljudfil du vill ladda upp').then((result) => {
            if (!result) resolve(false);

            const data = new Object as MediaData;
            data.mediaid = 0;
            data.mediafile = '';
            data.comment = '';

            uploadFile('audio', Cookie.pagename)
                .then( async (fresolve: string | false) => {
                    if (!fresolve) resolve(false);

                    data.mediafile = fresolve as string;
                    simpleForm('Ljud', 4, 'Lägg till kommentar', '',
                        'Skiv din kommentar här eller lämna tomt om du inte vill lägga till en')
                        .then((text: string) => {
                            data.comment = text;
                        });

                    yesNo('Skugga', 'Vill du att ljudfilen ska ha skuggning?')
                        .then((result: boolean) => {
                            data.shadow = result;
                        });

                    const resp = await api<{ data: MediaData }>('createSection', {
                        pos: Elements.contentContainer.childElementCount,
                        pagename: Cookie.pagename,
                        data: data,
                        type: 'audio'
                    });
                    if (resp) {
                        const section = new AudioSection(resp.data);
                        section.render();
                        section.enableEdit = true;
                        section.beginEdit();
                        resolve(true);
                    }

                });
            resolve(false);
        });
    });
}